export const entries = <T extends object>(obj: T) =>
  Object.entries(obj) as Array<[keyof T, T[keyof T]]>

export const fromEntries = <K extends string, V>(entries: Array<[K, V]>) =>
  Object.fromEntries(entries) as Record<K, V>

export const values = <K extends string, V>(obj: Record<K, V>) =>
  Object.values(obj) as V[]
